import * as React from 'react';
import clsx from 'clsx';
import { createContext } from '../../../utils';
import { Base } from '../../Base';
import Svg from '../../Svg';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "Heading-root_qjwKO",
  "iconWrapper": "Heading-iconWrapper_1yqIU",
  "icon": "Heading-icon_3Dcoc",
  "fontSize-xxl": "Heading-fontSize-xxl_1Oefz",
  "fontSize-xl": "Heading-fontSize-xl_3IyJ-",
  "fontSize-l": "Heading-fontSize-l_1-X3s",
  "fontSize-m": "Heading-fontSize-m_iGgm6",
  "fontSize-s": "Heading-fontSize-s_RYraS",
  "fontSize-xs": "Heading-fontSize-xs_2oNUB",
  "fontSize-display-xxl": "Heading-fontSize-display-xxl_1HqHQ",
  "fontSize-display-xl": "Heading-fontSize-display-xl_2jlWK",
  "fontSize-display-l": "Heading-fontSize-display-l_3n-tp",
  "fontSize-display-m": "Heading-fontSize-display-m_2VS7O",
  "fontSize-display-s": "Heading-fontSize-display-s_UTa6y",
  "fontSize-display-xs": "Heading-fontSize-display-xs_xHfyn"
};
const [HeadingProvider, useHeadingContext] = createContext('Heading');
const fontSizeToIconSize = {
  xs: null,
  s: '4x',
  m: '5x',
  l: '5x',
  xl: '5x',
  xxl: null
};
function Root({
  as = 'h2',
  fontFamily = 'text',
  fontSize = 'xl',
  children: childrenProp,
  className,
  ...extraProps
}, ref) {
  const {
    iconStart,
    iconEnd,
    children
  } = React.Children.toArray(childrenProp).reduce((slots, child) => {
    if (/*#__PURE__*/React.isValidElement(child) && child?.props?.slot) {
      slots[child.props.slot] = child;
      return slots;
    }
    slots.children.push(child);
    return slots;
  }, {
    iconStart: null,
    iconEnd: null,
    children: []
  });
  return /*#__PURE__*/_jsx(Base, {
    innerRef: ref,
    tagName: as,
    flex: true,
    gap: "xsmall",
    fontFamily: fontFamily,
    weight: "semibold",
    marginBottom: "none",
    className: clsx(styles.root, styles[`fontSize-${fontFamily === 'display' ? 'display-' : ''}${fontSize}`], className),
    ...extraProps,
    children: /*#__PURE__*/_jsxs(HeadingProvider, {
      fontSize: fontSize,
      children: [iconStart, children, iconEnd]
    })
  });
}
function Icon({
  id,
  title,
  name,
  size: sizeProp,
  theme,
  slot = 'iconStart',
  className,
  ...extraProps
}) {
  const {
    fontSize
  } = useHeadingContext('HeadingIcon');
  const size = sizeProp || fontSizeToIconSize[fontSize];
  if (!size) return null;
  return /*#__PURE__*/_jsx(Base, {
    tagName: "span",
    slot: slot,
    flex: true,
    flexAlignItemsCenter: true,
    className: clsx(styles.iconWrapper, className),
    ...extraProps,
    children: /*#__PURE__*/_jsx(Svg, {
      id: id,
      title: title,
      name: name,
      size: size,
      theme: theme,
      className: styles.icon
    })
  });
}
const Heading = /*#__PURE__*/React.forwardRef(Root);
Heading.displayName = 'Heading';
Icon.displayName = 'HeadingIcon';
export { Heading, Icon as HeadingIcon };